import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
import ButtonGroupContext from "./button-group.context.js";
function ButtonGroup(props) {
    const { className, variant, shape, size, color, block, hairline, disabled, ...restProps } = props;
    return (React.createElement(ButtonGroupContext.Provider, { value: {
            variant,
            size,
            color,
            shape,
            hairline,
            disabled,
        } },
        React.createElement(View, { className: classNames(prefixClassname("button-group"), {
                [prefixClassname("button-group--contained")]: variant === "contained",
                [prefixClassname("button-group--text")]: variant === "text",
                [prefixClassname("button-group--outlined")]: variant === "outlined",
                [prefixClassname("button-group--round")]: shape === "round",
                [prefixClassname("button-group--block")]: block,
            }, className), ...restProps })));
}
export default ButtonGroup;
